export const ACTIVE_MCA_STATUSES = ["PENDING", "IN_PROGRESS", "REJECTED"];

export const isMcaIntercepted = (result) => !!result?.data?.mcaIntercepted;

export const getMcaApprovingBannerTitle = (action, status) => {
  const actionLabels = {
    CREATE: "Create",
    UPDATE: "Update",
    DELETE: "Delete",
  };
  const actionLabel = actionLabels[action] ?? action ?? "Change";
  if (status === "REJECTED") {
    return `${actionLabel} rejected`;
  }
  return `Approving for ${actionLabel}`;
};

export const getMcaSubmittedNotificationTitle = () => `Submitted for approval`;

export const getMcaSubmittedNotificationMessage = (result) => {
  const action = result?.data?.mcaRequest?.action;
  const actionLabels = {
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
  };
  const verb = actionLabels[action] ?? "change";
  return (
    result?.data?.message ??
    `Your ${verb} request will apply after approval.`
  );
};

export const getMcaApprovalLabel = (action, status) => {
  if (status === "REJECTED") {
    const actionLabels = {
      CREATE: "Create",
      UPDATE: "Update",
      DELETE: "Delete",
    };
    const actionLabel = actionLabels[action] ?? action ?? "Change";
    return `${actionLabel} Rejected`;
  }
  return "Under Approval";
};

export const formatMcaApprovalStepProgress = (request) => {
  const totalSteps = request?.totalSteps;
  if (!totalSteps) return null;
  const currentStep = (request.currentStep ?? 0) + 1;
  return `(${currentStep}/${totalSteps})`;
};

export const getMcaApprovalTooltip = (request) => {
  if (!request) return null;
  const processName = request.process?.name ?? "Approval";
  const progress = formatMcaApprovalStepProgress(request);
  if (request.status === "REJECTED") {
    return progress
      ? `Rejected: ${processName} ${progress}`
      : `Rejected: ${processName}`;
  }
  return progress
    ? `Under Approval ${processName} ${progress}`
    : `Under Approval ${processName}`;
};

export const getMcaApprovalBadgeColor = (status) =>
  status === "REJECTED" ? "red" : "orange";

const resolveRequestId = (request) => {
  if (!request) return null;
  if (typeof request === "string") return request;
  return request._id ?? null;
};

export const isEntityMcaLocked = (entity) => !!getActiveMcaRequest(entity);

export const getActiveMcaRequest = (entity) => {
  const request = entity?.mcaRequestId;
  if (!request) return null;

  if (typeof request !== "object") {
    if (!entity?.mcaPending) return null;
    return {
      _id: request,
      action: "CREATE",
      status: "PENDING",
    };
  }

  if (!ACTIVE_MCA_STATUSES.includes(request.status)) return null;
  return request;
};

export const getMcaRequestId = (entity) => {
  const active = getActiveMcaRequest(entity);
  return active?._id ?? resolveRequestId(entity?.mcaRequestId);
};
